import { render, staticRenderFns } from "./RetailIcon.vue?vue&type=template&id=17ec3a84&"
import script from "./RetailIcon.vue?vue&type=script&lang=js&"
export * from "./RetailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports